import React, { useState } from 'react';
import {
  Button,
  Input,
  Label,
  Text,
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';
import OrderDetailsDialog from '../components/OrderDetailsDialog';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    ...shorthands.padding('24px'),
    maxWidth: '600px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    ...shorthands.padding('20px'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('4px'),
    boxShadow: tokens.shadow4,
  },
  row: {
    display: 'flex',
    gap: '8px',
    alignItems: 'flex-end',
  },
  hint: {
    color: tokens.colorNeutralForeground3,
    fontSize: '12px',
  },
});

export default function OrderDialogPreview() {
  const styles = useStyles();
  const [orderId, setOrderId] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <div className={styles.container}>
      <Text size={600} weight="semibold">OrderDetailsDialog preview</Text>
      <div className={styles.card}>
        <Label htmlFor="order-id-input">Booqable order ID</Label>
        <div className={styles.row}>
          <Input
            id="order-id-input"
            value={orderId}
            onChange={(_, data) => setOrderId(data.value)}
            placeholder="e.g. a1b2c3d4-..."
            style={{ flex: 1 }}
          />
          <Button
            appearance="primary"
            disabled={!orderId.trim()}
            onClick={() => setDialogOpen(true)}
          >
            Open dialog
          </Button>
        </div>
        <Text className={styles.hint}>
          Dialog calls GET /booqable/orders/&lt;id&gt; on open. Paste a real order
          UUID from the Orders list to see the populated view.
        </Text>
      </div>
      <OrderDetailsDialog
        isOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
        orderId={orderId.trim() || null}
      />
    </div>
  );
}
